// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Access Data Fetcher.
 */

import fetch from 'share/fetch/Izenda.Fetch';
import CacheUtils from 'share/utils/Izenda.CacheUtils';

const ROOT_URL = 'accessright/';

export default {
  /**
   * Get all access right
   * @param {String} saveType
   * @returns {promise}
   */
  loadAccessRight: CacheUtils.memoize(type => fetch(`${ROOT_URL}reportDashboard/${type}`).get()),

  /**
   * Get all access right for tenant settings
   * @param {String} saveType
   * @returns {promise}
   */
  loadTenantSettingAccessRight(type: string): any {
    return fetch(`${ROOT_URL}authentication/${type}`).get();
  },

  /**
   * Load accesses
   * @param  {string} tenantId
   * @param  {Object} subscriptions
   * @param  {Object} pageInfo
   */
  loadAccesses(data: any, pageInfo: any): any {
    pageInfo = pageInfo || {};

    const requestData = {
      accesses: data,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'shareWith', descending: true }]
    };

    return fetch(`${ROOT_URL}load`).post(requestData);
  },

  /**
   * Validation tenant accesses
   * @param  {object} requestData
   */
  validateAccesses(requestData: any): any {
    return fetch(`${ROOT_URL}validate`).post(requestData);
  },

  /**
   * Load access default for report/ dash board when create new document
   * @param  {int} type  type of document
   * @return {Promise}
   */
  loadDefaultAccess(type: number): any {
    return fetch(`${ROOT_URL}loadAccessDefaults/${type}`).get();
  },

  /**
   * Load users access
   * @return {Promise}
   */
  loadUsersAccess(data: any): any {
    return fetch(`${ROOT_URL}users`).post(data);
  },

  /**
   * Load roles access
   * @return {Promise}
   */
  loadRolesAccess(data: any): any {
    return fetch(`${ROOT_URL}roles`).post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.AccessDataFetcher.js